import { useContext } from 'react'
import cn from 'classnames'
import BrandingContext from '../context/BrandingContext'

const TextButton = (props) => {
  const {
    theme = 'primary',
    className,
    children,
    disabled,
    size = 'sm',
    as: Component = 'button',
    ...rest
  } = props

  const [branding] = useContext(BrandingContext)
  const { primaryColorPalette } = branding

  const buttonCn = cn('font-medium rounded-md', {
    'text-xs': size === 'xs',
    'text-sm': size === 'sm',
    'hover:underline focus:outline-hidden focus:underline': !disabled,
    [`text-${primaryColorPalette}-600 focus:ring-${primaryColorPalette}-600'`]:
      theme === 'primary' && !disabled,
    'text-gray-500 focus:ring-gray-600': theme === 'secondary' && !disabled,
    'text-red-600 focus:ring-red-600': theme === 'danger' && !disabled,
    'text-orange-700 focus:rind-orange-600': theme === 'accent' && !disabled,
    'text-gray-300': disabled,
    [className]: className,
  })

  return (
    <Component className={buttonCn} type="button" disabled={disabled} {...rest}>
      {children}
    </Component>
  )
}

export default TextButton
